import { lazyRetry } from "helpers/lazyRetry";

export default lazyRetry(() => import("./CreditNotes"));
